import { render, staticRenderFns } from "./IncomeInput.vue?vue&type=template&id=c98ae114&scoped=true&"
import script from "./IncomeInput.vue?vue&type=script&lang=js&"
export * from "./IncomeInput.vue?vue&type=script&lang=js&"
import style0 from "./IncomeInput.vue?vue&type=style&index=0&id=c98ae114&scoped=true&lang=scss&"
import style1 from "./IncomeInput.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98ae114",
  null
  
)

component.options.__file = "IncomeInput.vue"
export default component.exports